export default __webpack_public_path__ + "static/media/DarkBlue0004.1c8d3220.png";